import { AangevraagdeLandelijkeFaciliteiten, useGetAangevraagdeLandelijkeFaciliteiten, vestigingStatusMap } from "@/entities/vestiging";
import { DossierSummaryCard, DossierSummaryCardSkeleton } from "@/features/dossier-details";
import { Dot, EmptyState, ErrorDisplay, Helptext } from "@/shared/components";

interface LandelijkeFaciliteitenProps {
    dossierNummer: string;
}

export function LandelijkeFaciliteitenSummary({ dossierNummer }: Readonly<LandelijkeFaciliteitenProps>) {
    const { data: landelijkeFaciliteitenAanvraag, isPending, error } = useGetAangevraagdeLandelijkeFaciliteiten(dossierNummer);

    if (isPending) {
        return <DossierSummaryCardSkeleton section="FaciliteitenLandelijk" />;
    }

    if (error) {
        return <ErrorDisplay error={error} title="Fout bij het laden van landelijke faciliteiten" />;
    }

    return (
        <DossierSummaryCard section="FaciliteitenLandelijk">
            {landelijkeFaciliteitenAanvraag ? (
                <LandelijkeFaciliteitenSummaryContent aanvraag={landelijkeFaciliteitenAanvraag} />
            ) : (
                <EmptyState className="pr-3 pl-4">Geen landelijke faciliteiten aangevraagd</EmptyState>
            )}
        </DossierSummaryCard>
    );
}

type LandelijkeFaciliteitenSummaryContentProps = {
    aanvraag: AangevraagdeLandelijkeFaciliteiten;
};

export function LandelijkeFaciliteitenSummaryContent({ aanvraag }: LandelijkeFaciliteitenSummaryContentProps) {
    const status = vestigingStatusMap[aanvraag.status];

    return (
        <div className="flex flex-row items-center justify-between pr-3 pl-4">
            <div className="flex flex-col items-start">
                <span className="text-content-emphasis text-m font-medium">Landelijke faciliteiten</span>
                <Helptext>Alle Kiosken en Stationshuiskamers</Helptext>
            </div>
            <div className="flex flex-row items-center justify-between gap-2">
                <span className="text-m font-normal">{status.label}</span>
                <Dot variant={status.dotVariant} />
            </div>
        </div>
    );
}
